<template>
  <div class="flex">
    <div class="flex items-center justify-center pr-2">
      <el-button type="text">学习分：</el-button>
      <el-tag>{{ score }}</el-tag>
    </div>
    <el-popover placement="bottom" width="100px" trigger="click">
      <div class="flex flex-col p-2">
        <div class="flex justify-center py-1">
          <el-button class="border-0 w-28 text-left" icon="el-icon-user-solid" @click="handleGoHome">返回首页
          </el-button>
        </div>
        <div class="flex justify-center py-1">
          <el-button class="border-0 w-28 text-left" icon="el-icon-user-solid" @click="handleEditUserinfo">个人信息
          </el-button>
        </div>
        <div class="flex justify-center py-1">
          <el-button class="border-0 w-28 text-left" icon="el-icon-lock" @click="handleEditPassword">修改密码
          </el-button>
        </div>
        <div class="flex justify-center py-1" v-if="userInfo['type']===1">
          <router-link to="/pages/panel/panel">
            <el-button class="border-0 w-28 text-left" icon="el-icon-ali-console">后台管理</el-button>
          </router-link>
        </div>
        <div class="flex justify-center py-1">
          <el-button class="border-0 w-28 text-left" icon="el-icon-s-grid" @click="handeShowQrcode">二维码
          </el-button>
        </div>
        <div class="flex justify-center py-1">
          <el-button class="border-0 w-28 text-left" icon="el-icon-ali-exit" @click="handleLogout">退出登录</el-button>
        </div>
      </div>
      <div slot="reference" class="h-full flex">
        <div class="h-full flex items-center">
          <el-avatar :src="avatar"></el-avatar>
        </div>
        <div class="h-full flex items-center">
          <el-button type="text" class="ml-2">{{ $cloud.userInfo().username }}</el-button>
        </div>
      </div>
    </el-popover>

    <!--    个人信息弹窗-->
    <userinfo :visible.sync="userinfoVisible"/>
    <!--    修改密码弹窗-->
    <password :visible.sync="passwordVisible"/>
    <!--    二维码弹窗-->
    <qrcode :visible.sync="qrcodeVisible"/>
  </div>
</template>
<script>
import Userinfo from "../Dialog/Userinfo.vue";
import Password from "../Dialog/Password.vue";
import Qrcode from "../Dialog/Qrcode.vue";

export default {
  name: "WebLayout",
  /**
   * 调用组建
   * @type {Object}
   */
  components: {Userinfo, Password, Qrcode},
  /**
   * 组建属性
   * @type {Object}
   */
  props: {},
  /**
   * 数据字段
   * @return {[type]} [description]
   */
  data() {
    return {
      userinfoVisible: false,
      passwordVisible: false,
      qrcodeVisible: false,
      score: 0,
      avatar: ''
    };
  },
  /**
   * 计算属性
   * @type {Object}
   */
  computed: {
    userInfo() {
      return this.$cloud.userInfo();
    }
  },
  /**
   * 数据监听
   * @type {Object}
   */
  watch: {},
  /**
   * 页面创建时
   * @return {[type]} [description]
   */
  created() {

  },
  /**
   * 页面加载时
   * @return {[type]} [description]
   */
  mounted() {
    this.getUserInfo()
  },
  /**
   * 页面调用函数
   * @type {Object}
   */
  methods: {
    getUserInfo() {
      this.$cloud.get('/account/index').then(res => {
        console.log("res", res)
        this.score = res.score || 0
        this.avatar = res.avatar || ''
      })
    },
    handleGoHome() {
      this.$cloud.go("/")
    },
    handleEditUserinfo() {
      console.log("修改用户信息")
      this.userinfoVisible = true
    },
    handleEditPassword() {
      console.log("修改密码")
      this.passwordVisible = true
    },
    handeShowQrcode() {
      console.log("显示二维码")
      this.qrcodeVisible = true
    },
    handleLogout() {
      console.log("退出登录")
      this.$confirm('是否退出登录?', '提示', {
        confirmButtonText: '退出',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$cloud.logout().then(() => {
          this.$message({
            type: 'success',
            message: '退出成功!'
          });
          setTimeout(() => {
            this.$cloud.go("/pages/login/login")
          }, 500)

        })
      })
    }
  }
};
</script>
<style>
.header-body, .main-body {
  width: 1200px;
  margin: 0 auto;
}

.home-menu .el-menu-item {
  font-weight: bolder;
}

.score {
  background: darkorange;
  height: 30px;
  line-height: 30px;
  color: #fff;
  padding: 0 10px;
  border-radius: 15px;
  width: 80px;
  text-align: center;
}
</style>
